module.exports = __webpack_public_path__ + "static/info7.ab86ae20.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mini_portal/Community/info7.png
// module id = 830
// module chunks = 68530290604204